import React, { FC } from 'react';
import { CheckoutLineItemsProps } from './CheckoutLineItemsProps';
import { calculateTotal } from '../../../../helpers/calculateTotal';

interface CheckoutBuiltItemType {
  lineId?: number;
  kind?: string;
  lineTotal?: number;
  grade?: string;
}

const CheckoutLineItemTile: FC<CheckoutLineItemsProps> = ({ items, type, grades, cartedItems }) => {
  const itemTitle = type.charAt(0).toUpperCase() + type.slice(1);

  const cartItems = cartedItems.map(ci => {
    const builtItem = {} as CheckoutBuiltItemType;
    builtItem.lineId = ci.lineId;
    builtItem.lineTotal = ci.lineTotal;
    builtItem.kind = items.find(item => item.id === ci[`${type}Id`])?.kind || ci[`${type}`]?.kind;
    if (grades || type === 'esrog') {
      builtItem.grade = grades?.find(grade => grade.id === ci.gradeId)?.grade || ci.grade?.grade;
    }

    return builtItem;
  });

  const kindTotal = calculateTotal(cartedItems, 'lineTotal');

  return (
    <>
      {cartedItems.length ? (
        <table className="table table-sm">
          <thead>
            <tr key={itemTitle}>
              <th scope="col">
                {itemTitle} ({cartedItems.length})
              </th>
              <th scope="col" className="text-muted pull-right">
                (${kindTotal})
              </th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map((cartItem, index) => (
              <tr key={`${cartItem}-${index}`}>
                <td>
                  {cartItem?.kind} {cartItem?.grade && <>- {cartItem?.grade}</>}
                </td>
                <td className="prices">${cartItem?.lineTotal}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <></>
      )}
    </>
  );
};

export default CheckoutLineItemTile;
